import { useEffect, useRef, useState } from 'react';

type TDebounceOptions = {
  initImmediately: boolean;
};

export const useDebounce = (value: any, delay: number, options: Partial<TDebounceOptions> = {}) => {
  const [debouncedValue, setDebouncedValue] = useState(options.initImmediately ? value : null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [value, delay]);

  return debouncedValue;
};
